export default __webpack_public_path__ + "static/rules-1-67d137224a6b912b28bef721d9e41258.png";